import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LectureAuthGuard } from '../lectures/shared/lecture-auth.guard';

import { LessonEditComponent } from './lesson-edit/lesson-edit.component';
import { LessonComponent } from './lesson/lesson.component';
import { LessonResolver } from './shared/lesson-resolver.service';

export const lessonRoute = {
  path: ':id',
  // canActivate: [LectureAuthGuard],
  resolve: {
    lesson: LessonResolver
  },
  children: [
    {
      path: '',
      pathMatch: 'full',
      component: LessonComponent
    },
    {
      path: 'edit',
      component: LessonEditComponent
    }
  ]
};

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LessonsRoutingModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lessons-routing.module.ts